import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { LoginFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
import ForgotPasswordForm from "./forgotPasswordForm";
//#region components
import { useAuthService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const ForgotPasswordFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const authService = useAuthService();
  const validationSchema = Yup.object<LoginFormTypes.ForgotPassword>({
    userName: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const defaultValues: LoginFormTypes.ForgotPassword = {
    userName: "",
  };

  const handleSubmit = (values: LoginFormTypes.ForgotPassword): Promise<any> => {
    return authService.sendResetEmail({ mail: values.userName });
  };

  return (
    <ForgotPasswordForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(ForgotPasswordFormContainer);
